<!-- let's create a skeleton for table, at least 10 rows -->
<template>
    <div class="hs-table-skeleton-wrap w-full overflow-x-auto">
        <table class="hs-table-skeleton-table w-full text-sm text-left">
            <thead class="hs-table-skeleton-head text-xs uppercase">
                <tr>
                    <template v-for="(width, index) in columnWidths" :key="index">
                        <th class="px-6 py-4">
                            <div :class="['hs-table-skeleton-bar animate-pulse', width]"></div>
                        </th>
                    </template>
                </tr>
            </thead>
            <tbody>
                <template v-for="n in rows" :key="n">
                    <tr>
                        <template v-for="(width, index) in columnWidths" :key="index">
                            <td class="px-6 py-4">
                                <div :class="['hs-table-skeleton-bar animate-pulse', index === 0 ? 'w-8' : width]"></div>
                            </td>
                        </template>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'HSTableSkeleton',
    props: {
        columns: {
            type: Number,
            default: 7
        },
        rows: {
            type: Number,
            default: 10
        }
    },
    computed: {
        columnWidths() {
            const defaultWidths = ['w-10', 'w-36', 'w-28', 'w-32', 'w-24', 'w-32', 'w-28', 'w-24', 'w-32'];
            return defaultWidths.slice(0, this.columns);
        }
    }
}
</script>

<style scoped>
.hs-table-skeleton-wrap {
    background:
        radial-gradient(circle at 8% 0%, color-mix(in srgb, var(--hs-primary, #3293ec) 8%, transparent), transparent 30%),
        color-mix(in srgb, var(--hs-surface, #ffffff) 92%, transparent);
    border: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
    border-radius: 22px;
    box-shadow: 0 18px 46px rgba(15, 23, 42, 0.08);
}

.hs-table-skeleton-table {
    min-width: 760px;
}

.hs-table-skeleton-head {
    background: color-mix(in srgb, var(--hs-bg-soft, #f1f5f9) 76%, transparent);
}

.hs-table-skeleton-table th,
.hs-table-skeleton-table td {
    border-bottom: 1px solid color-mix(in srgb, var(--hs-border, rgba(148, 163, 184, 0.22)) 68%, transparent);
}

.hs-table-skeleton-bar {
    background: linear-gradient(90deg,
            color-mix(in srgb, var(--hs-border, #cbd5e1) 65%, transparent),
            color-mix(in srgb, var(--hs-primary, #3293ec) 10%, transparent),
            color-mix(in srgb, var(--hs-border, #cbd5e1) 65%, transparent));
    border-radius: 999px;
    height: 0.92rem;
}

.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: .5;
    }
}
</style>
